import { getContactsFieldByTagsAsync, getAllTriggersByTopicExternalIdAsync } from "../../~api/actions";

import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { ContactField } from "../../~types/models/ConctactField";
import { TopicPairStatus } from "../../../../../nlp/~store/models/enums/TopicPairStatus";

export const getContactsFieldByTags = async (
    count: number,
    searchString: string,
    searchTags: ISearchingTag[],
    contactField: ContactField
) => {
    const result = (await getContactsFieldByTagsAsync(count, searchString, searchTags, contactField));

    return result.value ?? [];
};

export const getAllTriggersByTopicExternalId = async (
    count: number,
    topicExternalId: string,
    searchString: string,
    topicPairStatus: TopicPairStatus | null = null
) => {
    const result = (await getAllTriggersByTopicExternalIdAsync(count, topicExternalId, searchString, topicPairStatus));

    return result.value ?? [];
};